import React, { useState, useEffect } from "react";
import ApiService from "../../../Services/user/service";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { MdWork } from "react-icons/md";
import { toast } from "react-toastify";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";
import { ArrowRightLeft } from "lucide-react";

const Portfolio = () => {
    const navigate = useNavigate();

    const user_id = localStorage.getItem("user_id");
    const currency = localStorage.getItem("currentCurrency");
    const [activeTab, setActiveTab] = useState("closed");
    const [inrdata, setInrData] = useState([]);
    const [holdingData, setHoldingData] = useState([]);
    const [InrModifyData, setInrModifyData] = useState(false);
    const [inrModifyModalOpen, setInrModifyModalOpen] = useState(false);
    const [UsdModifyData, setUsdModifyData] = useState(false);
    const [usdModifyModalOpen, setUsdModifyModalOpen] = useState(false);
    const [isSquareoffModalOpen, setIsSquareoffModalOpen] = useState(false);
    const [squareoffModalOpenUsd, setSquareoffModalOpenUsd] = useState(false);
    const [squareoffData, setSquareoffData] = useState("");
    const [squareLot, setSquareLot] = useState("");
    const [totalLot, setTotalLot] = useState(0);
    const [closedata, setClosedata] = useState("");
    const [convertModalOpen, setConvertModalOpen] = useState(false);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const [slError, setSlError] = useState("");
    const [targetError, setTargetError] = useState("");

    const [modifyPrice, setModifyPrice] = useState(InrModifyData?.price || "");
    const [target, setTarget] = useState("");
    const [stopLoss, setStopLoss] = useState("");


    const [targetInr, setTargetInr] = useState("");
    const [stopLossInr, setStopLossInr] = useState("");


    const [isStatementModalOpen, setIsStatementModalOpen] = useState(false);
    const [statementData, setStatementData] = useState(null);

    useEffect(() => {
        if (squareoffModalOpenUsd && closedata) {
            const lot =
                Number(closedata.buy_lot || 0) -
                Number(closedata.sell_lot || 0);

            setTotalLot(lot);
            setSquareLot(lot.toString()); // auto fill
        }
    }, [squareoffModalOpenUsd, closedata]);



    const fetchPositionData = async () => {
        try {
            let res;
            if (currency === "1") {
                res = await ApiService.PositionInr({ userid: user_id });
            } else {
                res = await ApiService.PositionUsd({ userid: user_id });
            }

            setInrData(res?.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };


    const fetchHoldingData = async () => {
        try {
            let res;
            if (currency === "1") {
                res = await ApiService.HoldingInr({ userid: user_id });
            } else {
                res = await ApiService.HoldingUsd({ userid: user_id });
            }

            setHoldingData(res?.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        fetchPositionData();
    }, []);

    const HandleViewStatement = () => {
        navigate("/user/trade-statement");
    };


    function HandleModifyInr(data) {
        setInrModifyData(data);
        setInrModifyModalOpen(true);
        setTargetInr(data.Target_price || "");
        setStopLossInr(data.stoploss_price || "");
    }


    function HandleModifyUsd(data) {
        setUsdModifyData(data);
        console.log(data);
        setTarget(data.Target_price || "");
        setStopLoss(data.stoploss_price || "");
        setUsdModifyModalOpen(true);
    }


    const summary = React.useMemo(() => {
        let data = [];

        if (activeTab === "open") {
            data = holdingData;   // Holding
        } else {
            data = inrdata;       // Positions
        }

        if (!data || data.length === 0) {
            return { invested: 0, current: 0, pnl: 0 };
        }

        return data.reduce(
            (acc, item) => {
                const buyPrice = Number(item.buy_price);
                const livePrice = Number(item.liveprice);
                const invested = Number(item.requiredFund || (buyPrice * item.buy_qty));

                if (!buyPrice || !livePrice || !invested) return acc;

                const current =
                    item.Mk_type === "forex"
                        ? (livePrice / buyPrice) * invested
                        : livePrice * item.buy_qty;

                acc.invested += invested;
                acc.current += current;
                acc.pnl += current - invested;

                return acc;
            },
            { invested: 0, current: 0, pnl: 0 }
        );
    }, [activeTab, holdingData, inrdata]);


    const HandleClosePosition = (item) => {
        const remainingLot = (
            Number(item.buy_lot || 0) - Number(item.sell_lot || 0)
        ).toFixed(5);   // 👈 jitni precision chahiye

        setSquareoffData(item);
        setTotalLot(Number(remainingLot));  // number for comparison
        setSquareLot(remainingLot);         // string for input

        setIsSquareoffModalOpen(true);
    };


    const handleSquareOff = async () => {
        const lot = Number(squareLot);

        // ✅ valid → API call
        try {
            const qty = lot * squareoffData.lotsize;
            const price = Number(squareoffData.buy_price);

            const payload = {
                userid: user_id,
                id: squareoffData._id,
                symbol: squareoffData.symbol,
                price,
                lot,
                qty,
                requiredFund: price * qty,
                type: "SELL",
                lotsize: squareoffData.lotsize,
                app_version: "1.0",
            };

            console.log("🔥 Squareoff Payload:", payload);

            const res = await ApiService.SquareoffInr(payload);

            if (res?.data?.status) {
                toast.success("Sell Order Update successfully");
                setIsSquareoffModalOpen(false);
                fetchPositionData();
            } else {
                toast.error(res?.data?.message || "Squareoff failed ❌");
            }

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong ❌");
        }
    };

    const HandleClosedUsdPosition = (item) => {
        setSquareoffModalOpenUsd(true);
        setClosedata(item);
        console.log("Closed Data:", item);
    }

    const handleSquareOffUsd = async () => {
        const lot = Number(squareLot);
        try {
            const qty = lot * closedata.lotsize;
            const price = Number(closedata.buy_price);

            const payload = {
                userid: user_id,
                id: closedata._id,
                symbol: closedata.symbol,
                price,
                lot,
                qty,
                requiredFund: price * qty,
                type: "SELL",
                lotsize: closedata.lotsize,
                app_version: "1.0",
            };

            console.log("🔥 Squareoff Payload:", payload);

            const res = await ApiService.SquareoffUsd(payload);

            if (res?.data?.status) {
                toast.success("Sell Order Update successfully ");
                setSquareoffModalOpenUsd(false);
                fetchPositionData();
            } else {
                toast.error(res?.data?.message || "Squareoff failed ❌");
            }

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong ❌");
        }
    }

    const handleConvertPosition = async (item) => {
        const payload = {
            user_id: user_id,
            id: item,
        };

        let res;
        console.log("Convert payload:", payload);
        if (currency === "1") {
            res = await ApiService.convertPositionInr(payload);
        } else {
            res = await ApiService.convertPosition(payload);
        }

        if (res?.data?.status) {
            toast.success("Position converted successfully");
            fetchPositionData();
            setConvertModalOpen(false);
        }
        else {
            toast.error(res?.data?.message || "Convert failed ❌");
        }
    };




    const handleUpdateOrder = async () => {
        try {

            if (target && stopLoss && Number(target) <= Number(stopLoss)) {
                setTargetError("Target must be greater than Stoploss");
                return;
            }

            setTargetError(""); // clear if valid

            if (!UsdModifyData?._id) {
                toast.error("Order ID missing");
                return;
            }

            const payload = {
                id: UsdModifyData._id,
                stoploss_price: stopLoss.toString(),
                Target_price: target.toString(),
            };

            console.log("FINAL PAYLOAD 🔥", payload);

            const res = await ApiService.stopLossUpdate(payload);

            if (res?.status) {
                toast.success("Target & Stoploss Updated");
                setUsdModifyModalOpen(false);
                fetchPositionData();
                fetchHoldingData();
            } else {
                toast.error(res?.message || "Update failed");
            }
        } catch (error) {
            console.log("Update error:", error);
            toast.error("Something went wrong");
        }
    };




    const handleTradeStatement = (item) => {
        navigate("/user/trade-statement", {
            state: {

                orderid: item._id   // 👈 ye backend ka orderid hai
            }
        });
    };


    const HandleViewStatementModal = async function (item) {
        console.log("Statement Item:", item);
        try {
            const type = currency === "1" ? "INR" : "USD";

            const payload = {
                orderid: [item._id],  // array me bhejna required hai
                type: type
            };

            console.log("Statement Payload:", payload);

            const res = await ApiService.viewStatement(payload);
            // Set response data into state
            setStatementData(res.data.data[0])

            console.log("Statement Response:", statementData);

            // Open modal
            setIsStatementModalOpen(true);

        } catch (error) {
            console.error("Statement Error:", error);
        }
    }

 
    const handleUpdateOrderInr = async () => {
  try {
    // 🔴 submit-time validation
    if (
      targetInr &&
      stopLossInr &&
      Number(targetInr) <= Number(stopLossInr)
    ) {
      setTargetError("Target must be greater than Stoploss");
      return;
    }

    setTargetError("");

    if (!InrModifyData?._id) {
      toast.error("Order ID missing");
      return;
    }

    const payload = {
      id: InrModifyData._id,
      stoploss_price: stopLossInr.toString(),
      Target_price: targetInr.toString(),
    };

    console.log("🔥 INR FINAL PAYLOAD:", payload);

    // ✅ API CALL (same API use hoti hai INR / USD dono ke liye)
    const res = await ApiService.stopLossUpdateInr(payload);

    if (res?.status || res?.data?.status) {
      toast.success("Target & Stoploss Updated");

      setInrModifyModalOpen(false);

      // 🔁 refresh data
      fetchPositionData();
      fetchHoldingData();
    } else {
      toast.error(res?.message || res?.data?.message || "Update failed");
    }
  } catch (error) {
    console.log("Update error:", error);
    toast.error("Something went wrong");
  }
};




    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="card-title">
                        <MdWork size={28} /> Portfolio</div>

                    <div className="wallet-tabs">
                        <div className="btn-group" role="group" style={{ gap: "2px" }}>
                            <button
                                className={`btn ${activeTab === "closed"
                                    ? "btn-primary"
                                    : "btn-outline-primary"
                                    }`}
                                onClick={() => {
                                    setActiveTab("closed");
                                    fetchPositionData();
                                }}
                            >
                                Positions
                            </button>

                            <button
                                className={`btn ${activeTab === "open" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => {
                                    setActiveTab("open");
                                    fetchHoldingData();
                                }}
                            >
                                Holding
                            </button>

                        </div>
                    </div>
                </div>

                <div className="card-body">
                    {/* SUMMARY CARD */}
                    <div className="summary-card">
                        <div>
                            <div className="summary-title">Total Invested</div>
                            <div className="summary-value">
                                {` ${(currency === "1" ? "₹" : "$")}${summary.invested.toLocaleString("en-IN")}`}
                            </div>
                        </div>

                        <div style={{ textAlign: "center" }}>
                            <div className="summary-title">Profit &amp; Loss</div>
                            <div
                                className="summary-profit"
                                style={{ color: summary.pnl >= 0 ? "green" : "red" }}
                            >
                                {summary.pnl >= 0 ? "+" : "-"}  {` ${(currency === "1" ? "₹" : "$")}`}{" "}
                                {Math.abs(summary.pnl).toLocaleString("en-IN")}
                            </div>
                        </div>

                        <div className="summary-right">
                            <div className="summary-title">Current Value</div>
                            <div className="summary-value">
                                {` ${(currency === "1" ? "₹" : "$")}${summary.current.toLocaleString("en-IN")} `}
                            </div>
                        </div>
                    </div>


                    {/* POSITION CARDS */}
                    {activeTab === "closed" && (
                        <div className="w-100">
                            {inrdata.length === 0 ? (
                                <p>No closed positions found</p>
                            ) : (
                                inrdata.map((item, index) => (
                                    <div
                                        key={index}
                                        className="card mb-3 holding-card statement-card"
                                    >
                                        <div className="card-body">
                                            <div className="row align-items-center">

                                                {/* LEFT SIDE */}
                                                <div className="col-md-9 holding-sections">
                                                    <div className="d-flex justify-content-between">

                                                        {/* SECTION 1 */}
                                                        <div className="flex-fill">
                                                            <div>
                                                                <strong>{item.symbol}</strong>
                                                            </div>
                                                            <div>
                                                                <span
                                                                    style={{
                                                                        color:
                                                                            item.buy_type === "buy" ? "green" : "red",
                                                                        fontWeight: "600",
                                                                    }}
                                                                >
                                                                  {(item?.buy_type ?? "").toUpperCase()}
                                                                </span>
                                                                {" "}• Lot: {item.buy_lot}
                                                                <br />
                                                            </div>
                                                        </div>

                                                        {/* SECTION 2 */}
                                                        <div className="flex-fill text-center">
                                                            <div>LTP</div>
                                                            <strong style={{ color: "#3a3d3fff" }}>
                                                                ${item.liveprice}
                                                            </strong>
                                                        </div>

                                                        {/* SECTION 3 */}
                                                        <div className="flex-fill text-center">
                                                            <div>Invested</div>
                                                            <strong>
                                                                ${(item.requiredFund).toFixed(3)}
                                                            </strong>
                                                        </div>

                                                        {/* SECTION 4 */}
                                                        <div className="flex-fill text-center">
                                                            <div>Current Value</div>
                                                            <strong>
                                                                ${(item.liveprice * item.buy_qty).toFixed(2)}
                                                            </strong>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* RIGHT SIDE BUTTONS */}
                                                <div className="col-md-3 text-end holding-buttons">
                                                    <button
                                                        className="btn btn-outline-success btn-sm me-2"
                                                        onClick={() =>
                                                            currency === "1"
                                                                ? HandleModifyInr(item)
                                                                : HandleModifyUsd(item)
                                                        }
                                                    >
                                                        Modify
                                                    </button>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm me-2"
                                                        onClick={() => HandleViewStatementModal(item)}
                                                    >
                                                        Statement
                                                    </button>

                                                    <button
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={() =>
                                                            currency === "1"
                                                                ? HandleClosePosition(item)
                                                                : HandleClosedUsdPosition(item)
                                                        }
                                                    >
                                                        Close
                                                    </button>
                                                    <ArrowRightLeft
                                                        size={22}
                                                        className="text-primary ms-3"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            setSelectedPosition(item._id);
                                                            setConvertModalOpen(true);
                                                        }}
                                                    />



                                                </div>
                                                <div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    )}


                    {/* HOLDING CARDS */}
                    {activeTab === "open" && (
                        <div className="w-100">
                            {holdingData.length === 0 ? (
                                <p>No holdings found</p>
                            ) : (
                                holdingData.map((item, index) => (
                                    <div key={index} className="card mb-3 holding-card statement-card"> {/* Custom class: holding-card for card-specific styles */}
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                {/* Left side: Sections 1-4 in a flex container */}
                                                <div className="col-md-9 holding-sections"> {/* Custom class: holding-sections for left-side styling */}
                                                    <div className="d-flex justify-content-between">
                                                        {/* SECTION 1 */}
                                                        <div className="flex-fill">
                                                            <div><strong>{item.symbol}</strong></div>
                                                            <div>
                                                                <span
                                                                    style={{
                                                                        color: item.buy_type === "BUY" ? "green" : "red",
                                                                        fontWeight: "600",
                                                                    }}
                                                                >
                                                                    {item.buy_type}
                                                                </span>
                                                                • Lot: {item.buy_lot}
                                                                <br />
                                                                Average Price: <strong>${item.buy_price}</strong>
                                                            </div>
                                                        </div>

                                                        {/* SECTION 2 */}
                                                        <div className="flex-fill text-center">
                                                            <div className="d-flex gap-1 justify-content-center">
                                                                LTP
                                                                <strong style={{ color: "#3a3d3fff" }}>
                                                                    ${item.liveprice}
                                                                </strong>
                                                            </div>
                                                            {item.stoploss_price && (
                                                                <div className="text-muted small" style={{ fontSize: "11px" }}>
                                                                    stoploss {item.stoploss_price}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* SECTION 3 */}
                                                        <div className="flex-fill text-center">
                                                            <div className="d-flex gap-1 justify-content-center">
                                                                <span>Invested</span>
                                                                <strong>
${(Number(item.buy_price || 0) * Number(item.buy_qty || 0)).toFixed(2)}
                                                                </strong>
                                                            </div>
                                                            {item.Target_price && (
                                                                <div className="text-muted" style={{ fontSize: "11px" }}>
                                                                    🎯 Target: {item.Target_price}
                                                                </div>
                                                            )}

                                                        </div>

                                                        {/* SECTION 4 */}
                                                        <div className="flex-fill text-center">
                                                            <div className="d-flex gap-1 justify-content-center">
                                                                <span>Current Value</span>
                                                                <strong>
                                                                    ${(item.liveprice * item.buy_qty).toFixed(2)}
                                                                </strong>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Right side: Action Buttons */}
                                                <div className="col-md-3 text-end holding-buttons"> {/* Custom class: holding-buttons for right-side styling */}
                                                    <button
                                                        className="btn btn-outline-success btn-sm me-2"
                                                        onClick={() =>
                                                            currency === "1"
                                                                ? HandleModifyInr(item)
                                                                : HandleModifyUsd(item)
                                                        }
                                                    >
                                                        Modify
                                                    </button>

                                                    <button
                                                        className="btn btn-outline-primary btn-sm me-2"
                                                        onClick={() => handleTradeStatement(item)}
                                                    >
                                                        Statement
                                                    </button>

                                                    <button
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={() =>
                                                            currency === "1"
                                                                ? HandleClosePosition(item)
                                                                : HandleClosedUsdPosition(item)
                                                        }
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    )}

                </div>
            </div>



            {convertModalOpen && selectedPosition && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content rounded-4">


                            <div className="modal-header">
                                <h5 className="modal-title text-dark fw-semibold">Convert Position ?</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setConvertModalOpen(false)}
                                />
                            </div>


                            <div className="modal-body">
                                <p>
                                    Are you sure you want to send position to Holding ?

                                </p>
                            </div>


                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setConvertModalOpen(false)}
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleConvertPosition(selectedPosition)}
                                >
                                    Confirm
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}



            {inrModifyModalOpen && InrModifyData && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Modify Order – {InrModifyData.symbol}
                                </h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setInrModifyModalOpen(false)}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body">

                                {/* READ ONLY DATA (API se) */}
                                <p><b>Stock Name:</b> {InrModifyData.symbol}</p>
                                <p><b>Price:</b> {InrModifyData.liveprice}</p>
                                <p><b>Purchased At:</b> ₹ {InrModifyData.buy_price}</p>
                                <p><b>Lot Size:</b> {InrModifyData.lotsize}</p>
                                <p><b>Type:</b> {InrModifyData.buy_type}</p>

                                <hr />

                                {/* INPUTS */}
                                <div className="mb-3">
                                    <label className="form-label">Target</label>
                                    <input
                                        type="number"
                                        className={`form-control ${targetError ? "is-invalid" : ""}`}
                                        placeholder="Enter Target"
                                        value={targetInr}
                                        onChange={(e) => {
                                            setTargetInr(e.target.value);
                                            setTargetError("");
                                        }}
                                    />

                                    {targetError && (
                                        <div className="invalid-feedback d-block">
                                            {targetError}
                                        </div>
                                    )}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Stop Loss</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Stop Loss"
                                        value={stopLossInr}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setStopLossInr(value);

                                            if (target && value && Number(value) >= Number(target)) {
                                                setSlError("Stoploss must be less than Target");
                                            } else {
                                                setSlError("");
                                            }
                                        }}
                                    />

                                    {slError && <small className="text-danger">{slError}</small>}

                                </div>


                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setInrModifyModalOpen(false)}
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-success"
                                    onClick={handleUpdateOrderInr}
                                >
                                    Update
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}




            {usdModifyModalOpen && UsdModifyData && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Modify Order – {UsdModifyData.symbol}
                                </h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setUsdModifyModalOpen(false)}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body">

                                {/* INFO ROWS */}
                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Stock Name</div>
                                    <div className="col-6 text-end fw-semibold">
                                        {UsdModifyData.symbol}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Live Price</div>
                                    <div className="col-6 text-end fw-semibold">
                                        ${UsdModifyData.liveprice}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Purchased At</div>
                                    <div className="col-6 text-end fw-semibold">
                                        ${UsdModifyData.buy_price}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-6 text-muted">Lot Size</div>
                                    <div className="col-6 text-end fw-semibold">
                                        {UsdModifyData.lotsize}
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-6 text-muted">Type</div>
                                    <div className="col-6 text-end">
                                        <span
                                            className={`badge ${UsdModifyData.buy_type === "buy"
                                                ? "bg-success"
                                                : "bg-danger"
                                                }`}
                                        >
                                            {UsdModifyData.buy_type}
                                        </span>
                                    </div>
                                </div>

                                <hr />

                                {/* INPUTS */}
                                <div className="mb-3">
                                    <label className="form-label">Target</label>
                                    <input
                                        type="number"
                                        className={`form-control ${targetError ? "is-invalid" : ""}`}
                                        placeholder="Enter Target"
                                        value={target}
                                        onChange={(e) => {
                                            setTarget(e.target.value);
                                            setTargetError("");
                                        }}
                                    />

                                    {targetError && (
                                        <div className="invalid-feedback d-block">
                                            {targetError}
                                        </div>
                                    )}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Stop Loss</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter Stop Loss"
                                        value={stopLoss}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setStopLoss(value);

                                            if (target && value && Number(value) >= Number(target)) {
                                                setSlError("Stoploss must be less than Target");
                                            } else {
                                                setSlError("");
                                            }
                                        }}
                                    />

                                    {slError && <small className="text-danger">{slError}</small>}

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => setUsdModifyModalOpen(false)}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-success px-4"
                                    disabled={!!slError}
                                    onClick={() => handleUpdateOrder()}
                                >
                                    Update
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}



            {isSquareoffModalOpen && squareoffData && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">Square Off</h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setIsSquareoffModalOpen(false)}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body px-4">

                                {/* 1️⃣ STOCK NAME */}
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted"> Stock Name</span>
                                    <div style={{ fontSize: "18px", fontWeight: 700 }}>
                                        {squareoffData.symbol}
                                    </div>
                                </div>

                                {/* 2️⃣ BUY PRICE */}
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted">Buy Price</span>
                                    <strong>₹ {squareoffData.buy_price}</strong>
                                </div>

                                {/* 3️⃣ LOT SIZE */}
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted">Lot Size</span>
                                    <strong>{squareoffData.lotsize}</strong>
                                </div>

                                {/* 4️⃣ SQUARE OFF LOT INPUT */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">
                                        Lot
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={squareLot}
                                        onChange={(e) => setSquareLot(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {Number(squareLot) > totalLot && (
                                        <small className="text-danger">
                                            Enter lot should be less than Total lot {totalLot}
                                        </small>
                                    )}


                                </div>



                                {/* 6️⃣ BUY / SELL QUANTITY */}
                                <div className="d-flex justify-content-between mb-3">
                                    <span className="text-muted">Buy / Sell Quantity</span>
                                    <strong>{squareLot}</strong>
                                </div>


                                {/* 7️⃣ BOTTOM ROW */}
                                <div
                                    className="d-flex justify-content-between p-2 rounded"
                                    style={{ background: "#f5f7fa", fontSize: "14px" }}
                                >
                                    <span>
                                        Buy Price: <strong>₹ {squareoffData.buy_price}</strong>
                                    </span>
                                    <span>
                                        Total Lot: <strong>{totalLot}</strong>
                                    </span>

                                </div>

                            </div>


                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setIsSquareoffModalOpen(false)}
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-danger"
                                    onClick={() => handleSquareOff(squareoffData, squareLot)}
                                >
                                    SELL
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}


            {squareoffModalOpenUsd && closedata && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">Square Off Position </h5>
                                <button
                                    className="btn-close"
                                    onClick={() => {
                                        setSquareoffModalOpenUsd(false);
                                        setSquareLot("");
                                    }}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body px-4">

                                {/* TOP INFO CARD */}
                                <div
                                    className="d-flex justify-content-between align-items-center mb-3 p-3 rounded-3"
                                    style={{
                                        background: "#f8f9fa",
                                        border: "1px solid #e9ecef",
                                    }}
                                >
                                    {/* LEFT */}
                                    <div>
                                        <div style={{ fontSize: "18px", fontWeight: 700 }}>
                                            {closedata.symbol}   {/* USDTUSD */}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                            Crypto
                                        </div>
                                    </div>

                                    {/* RIGHT */}
                                    <div className="text-end">
                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                            Live Price
                                        </div>
                                        <div style={{ fontSize: "18px", fontWeight: 700 }}>
                                            ${Number(closedata.liveprice || 0).toFixed(4)}
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mb-3">
                                    <span className="text-muted">Profit / Loss</span>

                                    <strong
                                        style={{
                                            color:
                                                (
                                                    (Number(closedata.liveprice || 0) -
                                                        Number(closedata.buy_price || 0)) *
                                                    (Number(squareLot || 0) * Number(closedata.lotsize || 0))
                                                ) >= 0
                                                    ? "green"
                                                    : "red",
                                            fontSize: "18px",
                                        }}
                                    >
                                        ${(
                                            (Number(closedata.liveprice || 0) -
                                                Number(closedata.buy_price || 0)) *
                                            (Number(squareLot || 0) * Number(closedata.lotsize || 0))
                                        ).toFixed(2)}
                                    </strong>
                                </div>

                                {/* LOT SIZE */}
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted">Lot Size</span>
                                    <strong>{closedata.lotsize}</strong>
                                </div>

                                {/* LOT INPUT */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Lot</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={squareLot}
                                        onChange={(e) => setSquareLot(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                    />

                                    {Number(squareLot) > totalLot && (
                                        <small className="text-danger">
                                            Enter lot should be less than Total lot {totalLot}
                                        </small>
                                    )}
                                </div>

                                {/* BUY / SELL LOT */}
                                <div className="d-flex justify-content-between mb-3">
                                    <span className="text-muted">Buy / Sell Lot</span>
                                    <strong>
                                        {(Number(squareLot || 0) * Number(closedata.lotsize || 0)).toFixed(1)}
                                    </strong>

                                </div>

                                {/* BOTTOM ROW */}
                                <div
                                    className="d-flex justify-content-between p-2 rounded"
                                    style={{ background: "#f5f7fa", fontSize: 14 }}
                                >
                                    <span>
                                        Buy Price: <strong>$ {closedata.buy_price}</strong>
                                    </span>
                                    <span>
                                        Total Lot: <strong>{totalLot}</strong>
                                    </span>
                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setSquareoffModalOpenUsd(false)}
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-danger"
                                    disabled={
                                        !squareLot ||
                                        Number(squareLot) <= 0 ||
                                        Number(squareLot) > totalLot
                                    }
                                    onClick={() => handleSquareOffUsd(closedata, squareLot)}
                                >
                                    SELL
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {isStatementModalOpen && statementData && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.55)" }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 rounded-4 shadow">

                            {/* HEADER */}
                            <div
                                className="modal-header border-0 text-white"
                                style={{ background: "linear-gradient(135deg,#1e0fa1ff,#1e0fa1ff)" }}
                            >
                                <h5 className="modal-title fw-semibold">
                                    {statementData.symbol} Statement
                                </h5>
                                <button
                                    className="btn-close btn-close-white"
                                    onClick={() => setIsStatementModalOpen(false)}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body px-4 pt-4 pb-2">


                                {/* STATEMENT ROWS */}
                                {[
                                    { label: "Symbol", value: statementData.symbol },
                                    {
                                        label: "Type",
                                        value: statementData.type,
                                        className:
                                            statementData.type === "DEBIT"
                                                ? "text-danger fw-semibold"
                                                : "text-success fw-semibold",
                                    },
                                    { label: "Brokerage", value: `${currency === "1" ? "₹" : "$"}${statementData.brokerage}` },
                                    { label: "Balance Used", value: `${currency === "1" ? "₹" : "$"} ${statementData.totalamount}` },
                                    {
                                        label: "Balance Before Order",
                                        value: `${currency === "1" ? "₹" : "$"}${Number(statementData.wallet_balance).toFixed(3)}`,
                                    },
                                    {
                                        label: "Balance After Order",
                                        value: `${currency === "1" ? "₹" : "$"}${Number(statementData.after_balance).toFixed(3)}`,
                                    },
                                    { label: "Date", value: statementData.createdAt },
                                ].map((item, index) => (
                                    <div key={index} className="d-flex align-items-center py-2">
                                        <div style={{ width: "45%", color: "#6c757d" }}>{item.label}</div>
                                        <div style={{ width: "55%" }} className={item.className || "fw-semibold"}>
                                            {item.value}
                                        </div>
                                    </div>
                                ))}

                                {/* MESSAGE */}
                                {statementData.message && (
                                    <div
                                        className="mt-3 p-2 rounded"
                                        style={{ background: "#f8f9fa", fontSize: "13px" }}
                                    >
                                        <span className="text-muted">Message :</span>{" "}
                                        <span className="fw-semibold">{statementData.message}</span>
                                    </div>
                                )}

                                {/* ORDER DETAILS BUTTON */}
                                {/* ORDER DETAILS SECTION */}
                                {showOrderDetails && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "5%",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            width: "60%",
                                            maxWidth: "420px",
                                            background: "#fff",
                                            borderRadius: "12px",
                                            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                                            zIndex: 1056,
                                        }}
                                    >
                                        {/* HEADER */}
                                        <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom rounded-2"
                                            style={{ background: "linear-gradient(135deg,#1e0fa1ff,#1e0fa1ff)" }}>
                                            <h6 className="mb-0 fw-bold text-white">Order Details </h6>
                                            <button
                                                className="btn-close btn-close-white"
                                                onClick={() => setShowOrderDetails(false)}
                                            />
                                        </div>

                                        {/* BODY */}
                                        <div className="p-3">
                                            {[
                                                { label: "Trade Symbol", value: statementData.symbol, className: "text-success fw-semibold" },
                                                { label: "Trade Date", value: statementData.createdAt },
                                                { label: "Net Amount", value: `${currency === "1" ? "₹" : "$"}${statementData.Amount}` },
                                                { label: "Price", value: `${currency === "1" ? "₹" : "$"}${statementData.price}` },
                                                { label: "Lot", value: statementData.lot },
                                                { label: "Quantity", value: statementData.qty },
                                                {
                                                    label: "Type",
                                                    value: statementData.type,
                                                    className:
                                                        statementData.type === "DEBIT"
                                                            ? "text-danger fw-semibold"
                                                            : "text-success fw-semibold",
                                                },
                                            ].map((item, index) => (
                                                <div key={index} className="d-flex py-1">
                                                    <div style={{ width: "45%", color: "#6c757d" }}>
                                                        {item.label}
                                                    </div>
                                                    <div
                                                        style={{ width: "55%" }}
                                                        className={item.className || "fw-semibold"}
                                                    >
                                                        {item.value}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                            </div>


                            {/* FOOTER */}
                            <div className="modal-footer border-0 d-flex justify-content-between align-items-center">

                                {/* LEFT SIDE BUTTON */}
                                <button
                                    className="btn btn-outline-primary btn-sm px-4"
                                    onClick={() => setShowOrderDetails(true)}
                                >
                                    Order Details
                                </button>

                                {/* RIGHT SIDE BUTTON */}
                                <button
                                    className="btn btn-secondary px-4"
                                    onClick={() => setIsStatementModalOpen(false)}
                                >
                                    Close
                                </button>

                            </div>


                        </div>

                    </div>

                </div>
            )}



        </div>
    );
};

export default Portfolio;
